/**
 * Constantes compartidas de la aplicación
 */

// Colecciones de Firebase
export const COLLECTIONS = {
  PRODUCTOS: 'Productos',
  PEDIDOS: 'Pedidos',
};

// Rutas de la aplicación
export const ROUTES = {
  HOME: '/',
  FUNDAS: '/fundas',
  ACCESORIOS: '/accesorios',
  VIDRIOS: '/vidrios',
  CARRITO: '/carrito',
  COMPRA_EXITOSA: '/compra-exitosa',
  PEDIDO_REGISTRADO: '/pedido-registrado',
  CHECKOUT_FAILURE: '/checkout/failure',
  CHECKOUT_PENDING: '/checkout/pending',
  LOGIN: '/login',
  ADMIN: '/admin',
  ADMIN_PRODUCTOS: '/admin/productos',
  ADMIN_PEDIDOS: '/pedidos',
};

// Categorías de productos
export const CATEGORIAS = {
  FUNDAS: 'fundas',
  ACCESORIOS: 'accesorios',
  VIDRIOS: 'vidrios',
};

// Estados de pedidos
export const ESTADOS_PEDIDO = {
  CREADO: 'CREADO',
  PENDIENTE: 'PENDIENTE',
  EN_PROCESO: 'EN_PROCESO',
  COMPLETADO: 'COMPLETADO',
  CANCELADO: 'CANCELADO',
};

// Configuración de precios
export const PRECIO_CONFIG = {
  MINIMO_MAYORISTA: 60000,
  CANTIDAD_MINIMA_MAYORISTA: 6,
  COMISION_HIGHER: 0.04, // 4%
  UMBRAL_DESCUENTO_MAYORISTA: 400000,
  DESCUENTO_MAYORISTA: 0.05,
};

export const CONTACTO = {
  WHATSAPP_NUMERO: '5491156067007',
  WHATSAPP_DISPLAY: '11-5606-7007',
  INSTAGRAM_URL: 'https://www.instagram.com/icase.oeste/',
  INSTAGRAM_HANDLE: '@icase.oeste',
};

export const INSTAGRAM_HIGHLIGHTS = [
  {
    id: 'combos-mayoristas',
    title: 'Combos mayoristas',
    description: 'Armá pedidos por cantidad con los combos que más salen.',
    cta: 'Ver combos',
    kind: 'post',
    url: 'https://www.instagram.com/p/Db4LSo1EeBU/',
    image: '/instagram/combos-mayoristas.svg',
  },
  {
    id: 'proceso-compra',
    title: 'Cómo comprar',
    description: 'El paso a paso para revendedores: pedido, pago y retiro o envío.',
    cta: 'Ver proceso',
    kind: 'reel',
    url: 'https://www.instagram.com/reel/DWVGhIgEREY/',
    image: '/instagram/proceso-compra.svg',
  },
  {
    id: 'tutorial-web',
    title: 'Tutorial de la web',
    description: 'Recorré el catálogo, el carrito y el checkout en un minuto.',
    cta: 'Ver tutorial',
    kind: 'reel',
    url: 'https://www.instagram.com/reel/DchZWV7R4uK/',
    image: '/instagram/tutorial-web.svg',
  },
];

// Storage keys
export const STORAGE_KEYS = {
  CARRITO: 'carrito',
  JWT_TOKEN: 'icase_jwt_token',
  MP_CHECKOUT_INTENT_ID: 'mp_checkout_intent_id',
  /** @deprecated usar MP_CHECKOUT_INTENT_ID */
  MP_CHECKOUT_PEDIDO_ID: 'mp_checkout_pedido_id',
  WHATSAPP_PEDIDO_PREFIX: 'whatsapp_pedido_',
};

